import React from 'react'
import { toMoney } from '@mobi/utils/money'
import { Icon } from '@mobi/component-library/Common/Icon'
import { Banner } from '@mobi/component-library/Common/V2/Banner'
import { BetCard } from '@mobi/betslip/Components/Common/BetCard'
import type { BetLoopKambiShareCoupon } from '@core/Areas/BetLoop/types'
import { BetCardTitle } from '@mobi/betslip/Components/Common/BetCardTitle'
import { formatKambiCurrencyToDollarDecimal } from '@core/Areas/KambiSports/helpers/currencyFormat'
import { getEventLink } from '@core/Areas/KambiSports/helpers/navigation'
import { CountdownStatus } from '../Common/CountdownStatus'
import { SameGameMulti } from '../SameGameMulti'

export const Multi: React.FC<{
  historyCoupon: BetLoopKambiShareCoupon
}> = ({ historyCoupon }) => {
  const legsCount = historyCoupon.couponRows.length
  const multiTitleText = `${legsCount} Leg Multi`
  const multiCombinedReturn = toMoney(
    formatKambiCurrencyToDollarDecimal(historyCoupon.bets[0].betOdds)
  )

  return (
    <>
      <BetCardTitle title={multiTitleText} rightComponent={multiCombinedReturn} />

      {historyCoupon.couponRows.map(couponRow => {
        if (couponRow.selectionType === 'BET_BUILDER' && couponRow.outcomeGroup) {
          const sameGameMultiOutcomeIds = couponRow.outcomeGroup.groups.flatMap(
            group => group.outcomeIds
          )
          const outcomes = historyCoupon.outcomes.filter(outcome =>
            sameGameMultiOutcomeIds.includes(outcome.outcomeId)
          )
          const events = historyCoupon.events.filter(event => event.eventId === outcomes[0].eventId)
          return (
            <BetCard.Container key={couponRow.index}>
              <SameGameMulti
                legCount={outcomes.length}
                event={events[0]}
                outcomes={outcomes}
                betOffers={historyCoupon.betOffers}
                betStaus={couponRow.status}
                playedOdds={couponRow.playedOdds}
              />
            </BetCard.Container>
          )
        }

        const outcome = historyCoupon.outcomes.find(
          outcome => outcome.outcomeId === couponRow.outcomeId
        )
        if (!outcome) {
          return !PRODUCTION ? <Banner text='Unable to match coupon' type='neutral' /> : null
        }

        const event = historyCoupon.events.find(e => e.eventId === outcome.eventId)

        const eventName = event?.eventName ?? 'Unknown Meeting'
        const eventId = event?.eventId

        const betOffer = historyCoupon.betOffers.find(
          betOffer => betOffer.betOfferId === outcome.betOfferId
        )

        return (
          <BetCard.Container key={outcome.outcomeId}>
            <BetCard.EventDetails
              key={outcome.outcomeId}
              iconComponent={<Icon size='1.6rem' type='tab' />}
              heading={eventName}
              statusComponent={
                <CountdownStatus
                  eventStartTimes={event?.eventStartDate ?? historyCoupon.events[0]?.eventStartDate}
                  betStatus={historyCoupon.bets[0].betStatus}
                />
              }
            />

            <BetCard.SelectionInfo
              key={outcome.betOfferId}
              iconComponent={<Icon size='1.6rem' type='tab' />}
              heading={outcome.label}
              subHeading={betOffer?.criterion}
              priceWin={
                couponRow?.playedOdds
                  ? formatKambiCurrencyToDollarDecimal(couponRow.playedOdds)
                  : undefined
              }
              linkInfo={
                eventId
                  ? {
                      pathname: getEventLink(eventId),
                    }
                  : undefined
              }
            />
          </BetCard.Container>
        )
      })}
    </>
  )
}
